import React, { useState } from "react";
import { useParams } from "react-router-dom";
import "./App.css";
import LoadingSpinner from "./LoadingSpinner"; // Adjust if in different path

const ResetPassword = () => {
  const { token } = useParams();
  const [newPassword, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const hexKey = '7c3932af93b283dae0c5173b9adffa299a87e33b92e13a9119e120d8249e199e';

  function hexToUint8Array(hex) {
    const array = new Uint8Array(hex.length / 2);
    for (let i = 0; i < array.length; i++) {
      array[i] = parseInt(hex.substr(i * 2, 2), 16);
    }
    return array;
  }

  async function encrypt(text) {
    const keyBytes = hexToUint8Array(hexKey);
    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    const cryptoKey = await window.crypto.subtle.importKey(
      'raw', keyBytes, { name: 'AES-GCM' }, false, ['encrypt']
    );
    const encoded = new TextEncoder().encode(text);
    const encrypted = await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv }, cryptoKey, encoded);
    const combined = new Uint8Array(iv.length + encrypted.byteLength);
    combined.set(iv);
    combined.set(new Uint8Array(encrypted), iv.length);
    return btoa(String.fromCharCode(...combined));
  }

async function decrypt(base64Text) {
  const keyBytes = hexToUint8Array(hexKey);

  // Decode base64 to raw bytes
  const binary = atob(base64Text);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  const iv = bytes.slice(0, 12); // first 12 bytes
  const authTag = bytes.slice(bytes.length - 16); // last 16 bytes
  const ciphertext = bytes.slice(12, bytes.length - 16); // remaining middle

  // Merge ciphertext + authTag (as required by WebCrypto)
  const encryptedBytes = new Uint8Array(ciphertext.length + authTag.length);
  encryptedBytes.set(ciphertext);
  encryptedBytes.set(authTag, ciphertext.length);

  const cryptoKey = await window.crypto.subtle.importKey(
    'raw',
    keyBytes,
    { name: 'AES-GCM' },
    false,
    ['decrypt']
  );

  try {
    const decrypted = await window.crypto.subtle.decrypt(
      { name: 'AES-GCM', iv },
      cryptoKey,
      encryptedBytes
    );

    return new TextDecoder().decode(decrypted);
  } catch (err) {
    console.error("Frontend Decryption Failed:", err);
    throw new Error("Decryption failed on frontend.");
  }
}



  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!token) return setMessage("Invalid or missing token.");
  if (newPassword !== confirmPassword) return setMessage("Passwords do not match.");

  setLoading(true);

  try {
    const encryptedPassword = await encrypt(JSON.stringify({ password: newPassword }));
    const response = await fetch(`https://ydgftsclz0.execute-api.ap-south-1.amazonaws.com/prod/auth/reset-password/${token}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: encryptedPassword }),
    });

    const raw = await response.text();
    
    let encrypted;
    try {
      const parsed = JSON.parse(raw);
      encrypted = parsed.message;
    } catch {
      encrypted = raw;
    }

    const decryptedText = await decrypt(encrypted);

    // ✅ Use safe JSON parsing
    let data;
    try {
      data = JSON.parse(decryptedText);
    } catch {
      data = { message: decryptedText };
    }

    if (data?.message?.toLowerCase().includes("successful")) {
      setPassword("");
      setConfirmPassword("");
      setMessage("Password reset successful!");
      setTimeout(() => window.location.href = "https://www.knowledge-sun.com", 2000);
    } else {
      setMessage(data.message || "Something went wrong.");
    }
  } catch (error) {
    console.error("Decryption error:", error);
    setMessage("An error occurred. Please try again.");
  } finally {
    setLoading(false);
  }
};

  const inputStyle = {
    width: "100%",
    padding: "12px 44px 12px 12px",
    marginBottom: "16px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "16px",
    backgroundColor: "#FFFFFF",
    color: "#000000",
    boxSizing: "border-box"
  };

  const eyeIconStyle = {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    fontSize: "22px",
    color: "#666"
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="App" style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#FB8C00"
    }}>
      <div style={{
        width: "100%",
        maxWidth: "420px",
        backgroundColor: "#FFFFFF",
        padding: "32px",
        borderRadius: "16px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
        color: "#000000",
        boxSizing: "border-box",
        position: "relative"
      }}>
        <h2 style={{
          marginBottom: "24px",
          color: "#000000",
          fontSize: "24px",
          fontWeight: "bold"
        }}>Reset Password</h2>

        <form onSubmit={handleSubmit}>
          <div style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={inputStyle}
            />
            <span
              className="material-icons"
              onClick={() => setShowPassword(!showPassword)}
              style={eyeIconStyle}
            >
              {showPassword ? "visibility_off" : "visibility"}
            </span>
          </div>

          <div style={{ position: "relative", marginBottom: "24px" }}>
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={inputStyle}
            />
            <span
              className="material-icons"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              style={eyeIconStyle}
            >
              {showConfirmPassword ? "visibility_off" : "visibility"}
            </span>
          </div>

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px",
              backgroundColor: "#FFC107",
              color: "#000000",
              fontWeight: "600",
              border: "none",
              borderRadius: "8px",
              fontSize: "16px",
              cursor: "pointer"
            }}
          >
            Submit
          </button>
        </form>

        {message && (
          <p style={{
            marginTop: "20px",
            textAlign: "center",
            color: message.toLowerCase().includes("successful") ? "#388e3c" : "#d32f2f",
            fontWeight: "500"
          }}>
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
